import React from 'react'
import useForm from 'react-hook-form'
import { RHFInput } from 'react-hook-form-input'
import useSnackbar from 'hooks/useSnackbar'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@material-ui/core'

import { InputCurrency } from 'components/Form'

import * as service from 'service'

const DialogTax = ({
  open,
  handleClose = () => {},
  onAction = () => {},
  taxType,
}) => {
  const { register, handleSubmit, setValue, errors } = useForm({
    defaultValues: {
      ...taxType,
    },
  })
  const snackbar = useSnackbar()

  const onSubmit = async data => {
    try {
      await service.recurrence.taxTypes.update({
        taxTypeId: taxType.id,
        taxType: data,
      })

      snackbar.open({
        message: 'Tipo de de imposto atualizado com sucesso!',
        variant: 'success',
      })
      onAction()
      handleClose()
    } catch {
      snackbar.open({
        message: 'Falha ao atualizar tipo de imposto!',
        variant: 'error',
      })
      handleClose()
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="new-tax">
      <DialogTitle id="form-dialog-title">
        <div>
          <Typography variant="h3">Editar tipo de imposto</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)} id="tax-form">
          <RHFInput
            as={
              <InputCurrency
                label="Valor mínimo mensal"
                margin="dense"
                fullWidth
                error={!!errors.minimumMonthlyAmount}
                helperText={
                  errors.minimumMonthlyAmount
                    ? errors.minimumMonthlyAmount.message
                    : 'Valor mínimo mensal para o faturamento do imposto.'
                }
              />
            }
            name="minimumMonthlyAmount"
            register={register}
            setValue={setValue}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          form="tax-form"
        >
          Salvar
        </Button>
        <Button onClick={handleClose} color="primary" variant="outlined">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogTax
